import { render, staticRenderFns } from "./AllProgramsMenu.vue?vue&type=template&id=233db586&"
import script from "./AllProgramsMenu.vue?vue&type=script&lang=js&"
export * from "./AllProgramsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports